import { LoadState } from '@docma-mm-core/model/load-state/load-state';
import { SyncState } from '@docma-mm-core/model/sync-state/sync-state';
import { ChangeState } from '@docma-mm-core/model/change-state/change-state';
import { LoadStatusEnum } from './load-state/load-state.enum';
import { BehaviorSubject } from 'rxjs';


export class MmModel<T> {


  private _data= new BehaviorSubject<T>(null);
  private _loadState = new BehaviorSubject<LoadState<T>>(new LoadState({status: LoadStatusEnum.NotLoaded, data: {} as T}));

  loadState$ = this._loadState.asObservable();
  data$ = this._data.asObservable();
  id?: number;
  uid?: string;




  constructor(init?: Partial<MmModel<T>>) {

    if (init) {
      this.id =  init.id;
      this.uid =  init.uid;
      if (init.loadState) {
        this.loadState = new LoadState(init.loadState);
      }
    }
    if (!this.data) {
      this.setData({} as T);
    }

    if (!this.loadState) {
      this.loadState = new LoadState({status: LoadStatusEnum.NotLoaded, data: {} as T});
    }
    this.intiSubscription();
  }


  protected intiSubscription() {
    this._loadState.subscribe(ls=> {
      if (ls.data) {
        if (ls.status === LoadStatusEnum.Loaded) {
          this.id = (ls.data as any).Id;
          this.uid = (ls.data as any).UniqueId;
        }
        this.setData(ls.data);
      }
    })
  }



  get loadState(): LoadState<T> {
    return this._loadState.value;
  }

  set loadState(v: LoadState<T>) {
    this._loadState.next(v);
  }


  protected setData(v: T) {
    this.id = this.id ??  (v as any).Id;
    this.uid = this.uid ?? (v as any).UniqueId;
    this._data.next(v);
  }

  get data(): T {
    return this._data.value;
  }


}
